module.exports = __parcel__import__.meta.resolve("gy4A1");